import classnames from 'classnames'
import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue } from 'recoil'

import styled from '@emotion/styled'
import {
  Flex,
  FlexItem,
  IconWarningTriangle,
  Link,
  LINK_VARIANT_EXTRALIGHT,
  Panel,
  SKELETON_LOADER_VARIANT_ONWHITE,
  SkeletonLoader,
  Text,
  TEXT_VARIANT_BOLD,
  Title,
  TITLE_VARIANT_M,
  TITLE_VARIANT_XL
} from 'mailup-web-components'
import './icons.scss'

import { modalShowHistoryState } from 'Pages/SourceEdit/recoil/state/modals'
import {
  lastUpdatedState,
  sourceState
} from 'Pages/SourceEdit/recoil/state/source'

const PanelLastUpdated = () => {
  const intl = useIntl()

  const { idSource } = useRecoilValue(sourceState)
  const { loading, error, loaded, isEnabled, updateDate, updateTime } =
    useRecoilValue(lastUpdatedState)
  const [{ updateHistory }, openModal] = useRecoilState(modalShowHistoryState)

  const handleClick = () => {
    openModal((prev) => ({ ...prev, show: true }))
  }

  return (
    <Panel>
      <Flex flexDirection='row' columnGap='32px'>
        <FlexItem>
          <span
            className={classnames('icon__updates', {
              icon__updates__active: !error && loaded
            })}
          />
        </FlexItem>
        <FlexItem>
          <Flex
            flexDirection='column'
            alignItems='flex-start'
            justifyContent='center'
          >
            <FlexItem>
              <Flex
                flexDirection='row'
                columnGap='8px'
                alignItems='baseline'
                flexWrap='wrap'
              >
                {loading ? (
                  <SkeletonLoader
                    variant={SKELETON_LOADER_VARIANT_ONWHITE}
                    height='28px'
                    width='16px'
                  />
                ) : (
                  (idSource === 0 || error) && (
                    <StyledTitle
                      variant={TITLE_VARIANT_XL}
                      error={error || idSource === 0}
                      bold
                    >
                      -
                    </StyledTitle>
                  )
                )}
                <StyledTitle
                  error={error || idSource === 0}
                  variant={TITLE_VARIANT_M}
                >
                  {intl.formatMessage({
                    id: 'Load.MailupCommon.LastUpdate'
                  })}
                </StyledTitle>
                {idSource !== 0 && (
                  <>
                    <StyledTitle variant={TITLE_VARIANT_XL} bold>
                      {updateDate}
                    </StyledTitle>
                    <Text variant={TEXT_VARIANT_BOLD}> {updateTime}</Text>
                  </>
                )}
              </Flex>
            </FlexItem>
            <FlexItem>
              <Link
                variant={LINK_VARIANT_EXTRALIGHT}
                onClick={handleClick}
                disabled={!isEnabled || loading || !idSource}
              >
                {intl.formatMessage({ id: 'Load.ContentsSouces.ShowHistory' })}
              </Link>
              {updateHistory && updateHistory.length
                ? updateHistory[0].Status === 2 && <StyledIcon />
                : null}
            </FlexItem>
          </Flex>
        </FlexItem>
      </Flex>
    </Panel>
  )
}

export default PanelLastUpdated

const StyledTitle = styled(Title)`
  ${({ error }) => error && 'color: var(--boulder) !important;'}
  ${({ bold }) => bold && 'font-weight: 500 !important'}
`

const StyledIcon = styled(IconWarningTriangle)`
  margin-left: 8px;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: inline-grid;
  place-content: center;
  color: var(--pure-white);
  background-color: var(--sunset-orange);

  svg {
    top: -1px !important;
    width: 13px;
    height: 13px;
  }
`
